import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/classify',
  component: Layout,
  redirect: '/classify/index',
  name: 'Classify',
  meta: {
    title: '分类管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'ClassifyIndex',
      component: () => import('@/views/classify/index.vue'),
      meta: {
        title: '分类管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/classify"
      },
    }
  ],
}

export default routes
